export default __webpack_public_path__ + "static/media/next-audio-3.62994450.mp3";